module.exports = __webpack_public_path__ + "img/34.3b7f32eb.svg";